<div id="w-card" class="watcher-card" *ngIf="watcher" [class.menu-open]="showMenu" [class.preview]="watcher?.isPreview">

    <div class="watcher-card-header">
        <ng-container *ngIf="!persistent; else persistentHeader">
            <app-flight-map *ngIf="flightOptionData" [originLabel]="flightOptionData.departureLocationName"
                [destinationLabel]="flightOptionData.arrivalLocationName"
                [generalDestinationType]="flightOptionData.arrivalGeneralType"></app-flight-map>

            <div class="watcher-info">
                <div class="watcher-name">
                    {{watcher.displayName}}
                </div>
                <div *ngIf="flightOptionData" class="mb8">
                    <div class="dates" *ngIf="flightOptionData.departureDateExact; else dateRangeTemplate">
                        Departing on {{d(flightOptionData.departureDateExact)}}</div>
                    <ng-template #dateRangeTemplate>
                        <div class="dates">
                            Departing Between {{d(flightOptionData.departureDateRangeStart)}} -
                            {{d(flightOptionData.departureDateRangeEnd)}}
                        </div>
                    </ng-template>
                </div>
                <div class="detail-row">
                    <div class="detail-item">
                        <div class="icon">
                            <app-svg-loader height="12px" url="assets/svg/clock-solid.svg"></app-svg-loader>
                        </div>
                        <div class="value">
                            <ng-container *ngIf="checkedAt; else watchingStatus">
                                Checked {{checkedAt}}
                            </ng-container>
                            <ng-template #watchingStatus>Agent is Watching</ng-template>
                            <ng-container *ngIf="restrictionBadges.length > 0">
                                &nbsp;•&nbsp;{{restrictionBadges.join(' • ')}}
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-template #persistentHeader>
            <app-flight-map *ngIf="!isLoading" [originLabel]="watcher.departureLocationName"
                [destinationLabel]="watcher.arrivalLocationName"
                [generalDestinationType]="watcher.arrivalGeneralType"></app-flight-map>

            <div class="watcher-info">
                <div class="watcher-name">
                    {{watcher.displayName || watcher.departureLocationName + ' → ' + (watcher.arrivalLocationName ||
                    watcher.arrivalGeneralType)}}
                </div>
                <div class="detail-row">
                    <div class="detail-item">
                        <div class="icon">
                            <app-svg-loader height="12px" url="assets/svg/clock-solid.svg"></app-svg-loader>
                        </div>
                        <div class="value">
                            <span class="text-capitalize-case">{{watcher.status}}</span>
                            <ng-container *ngIf="restrictionBadges.length > 0">
                                &nbsp;•&nbsp;{{restrictionBadges.join(' • ')}}
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>

    <ng-container *ngIf="!watcher.isPreview">
        <div class="watcher-card-actions-wrapper" *ngIf="watcher.discoveredFlights?.length > 0">
            <div class="watcher-card-button" (click)="onClickViewOptions()"
                [ngClass]="{'no-action': !watcher.discoveredFlights}">

                <div class="action">
                    {{watcher.discoveredFlights?.length || 0}} Option<span
                        *ngIf="watcher.discoveredFlights?.length > 1">s</span>
                </div>
                <div class="icon">
                    <app-svg-loader height="20px" url="assets/svg/back-cube.svg"></app-svg-loader>
                </div>
            </div>
        </div>

        <div class="watcher-card-actions-wrapper"
            *ngIf="!watcher.discoveredFlights || watcher.discoveredFlights?.length === 0">
            <div class="no-options-button">
                No Options Yet
            </div>
        </div>
    </ng-container>

    <div class="watcher-menu-button" (click)="onShowMenu()" *ngIf="!watcher.isPreview || allowPreviewMenu">
        <app-svg-loader color="var(--icon-featured-bg)" height="20px"
            url="assets/svg/settings-toggle-bars.svg"></app-svg-loader>
    </div>

    <div #menu class="watcher-menu" *ngIf="showMenu">
        <div class="menu-header">
            <div class="label">Options</div>
        </div>
        <ng-container *ngIf="!persistent; else persistentMenu">
            <ng-container *ngIf="!watcher.isPreview; else previewStandardMenu">
                <div class="menu-item" (click)="onClickTogglePrivacy()" *ngIf="flightOptionData">
                    <div class="icon">
                        <app-svg-loader height="14px" url="assets/svg/lock-outline.svg"></app-svg-loader>
                    </div>
                    <div class="stacked-label">
                        <div class="text">
                            <span *ngIf="flightOptionData.isVisible">Public</span>
                            <span *ngIf="!flightOptionData.isVisible">Private</span>
                        </div>
                        <div class="desc">
                            <span *ngIf="flightOptionData.isVisible">Others Can Contact You</span>
                            <span *ngIf="!flightOptionData.isVisible">Others Can't Contact You</span>
                        </div>
                    </div>
                </div>
                <div class="menu-item" (click)="onClickDelete(watcher)">
                    <div class="icon">
                        <app-svg-loader height="18px" url="assets/svg/trash-outline.svg"></app-svg-loader>
                    </div>
                    Delete Watcher
                </div>
            </ng-container>
        </ng-container>

        <ng-template #previewStandardMenu>
            <div class="menu-item" (click)="onClickDelete(watcher)">
                <div class="icon">
                    <app-svg-loader height="18px" url="assets/svg/trash-outline.svg"></app-svg-loader>
                </div>
                {{previewMenuRemoveLabel}}
            </div>
        </ng-template>

        <ng-template #persistentMenu>
            <ng-container *ngIf="!watcher.isPreview; else previewPersistentMenu">
                <div class="menu-item" (click)="onClickToggleStatus()">
                    <div class="icon">
                        <app-svg-loader height="14px" url="assets/svg/bell-off-outline.svg"
                            *ngIf="watcher.status === 'active'"></app-svg-loader>
                        <app-svg-loader height="14px" url="assets/svg/bell-outline.svg"
                            *ngIf="watcher.status !== 'active'"></app-svg-loader>
                    </div>
                    <div class="stacked-label">
                        <div class="text">{{watcher.status === 'active' ? 'Pause' : 'Resume'}}</div>
                        <div class="desc">{{watcher.status === 'active' ? 'Temporarily stop alerts' : 'Receive alerts again'}}</div>
                    </div>
                </div>
                <div class="menu-item" (click)="onClickDelete(watcher)">
                    <div class="icon">
                        <app-svg-loader height="18px" url="assets/svg/trash-outline.svg"></app-svg-loader>
                    </div>
                    Delete Watcher
                </div>
            </ng-container>
        </ng-template>

        <ng-template #previewPersistentMenu>
            <div class="menu-item" (click)="onClickDelete(watcher)">
                <div class="icon">
                    <app-svg-loader height="18px" url="assets/svg/trash-outline.svg"></app-svg-loader>
                </div>
                {{previewMenuRemoveLabel}}
            </div>
        </ng-template>
    </div>
</div>